export const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100vw',
    minHeight: '100vh',
    backgroundColor: 'background.default',
    padding: { xs: 2, sm: 3 },
  },
  subWrapper: {
    margin: 'auto',
    width: '100%',
    maxWidth: 500,
    height: 'max-content',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  paper: {
    backgroundColor: 'background.default',
    display: 'flex',
    flexDirection: 'column',
    mb: 2,
    height: 'max-content',
    width: '100%',
    p: { xs: 2, sm: 3 },
  },
  accountsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  progressCircle: {
    alignSelf: 'center',
  },
  accountsSubContainer: {
    display: 'flex',
    flexDirection: 'row',
    height: 'fit-content',
    alignItems: 'center',
    justifyContent: 'center',
  },
  accountsSubC: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: { xs: '400px', sm: '500px' },
    width: '100%',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: 5,
    },
    '&::-webkit-scrollbar-track': {
      width: 5,
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#888',
      borderRadius: 10,
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#555',
    },
  },
  accountRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    mx: { xs: 1, sm: 2 },
    my: 1,
    p: { xs: 1.5, sm: 1 },
    borderRadius: 2,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
      cursor: 'pointer',
    },
  },
  accountImageWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: { xs: 50, sm: 90 },
    mr: { xs: 1.5, sm: 2 },
    '& img': {
      width: { xs: 32, sm: 40 },
      height: { xs: 32, sm: 40 },
    },
  },
  accountTextWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    flex: 1,
    minWidth: 0, 
    '& .MuiTypography-root:first-of-type': {
      width: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontSize: { xs: '0.9rem', sm: '1rem' },
    },
    '& .MuiTypography-root:last-of-type': {
      fontSize: { xs: '0.75rem', sm: '0.875rem' },
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      width: '100%',
    },
  },
};
